import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import axios from 'axios';

// require('./product-reviews.scss');

//api format
//https://readservices-b2c.powerreviews.com/m/689225/l/en_US/product/05689339/reviews?apikey=e17667f7-827b-4880-8fe1-ab55b0a692b9
export class ProductDetailReviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.sortOrder = 'Newest';
    this.fetchReviews = this.fetchReviews.bind(this);
    this.updateSortBy = this.updateSortBy.bind(this);
    this.goToNextPage = this.goToNextPage.bind(this);
    this.goToPrevPage = this.goToPrevPage.bind(this);
    this.goToReviewSection = this.goToReviewSection.bind(this);
    this.lazyLoadReviews = this.lazyLoadReviews.bind(this);
    this.lazyLoadReviewsAfterQV = this.lazyLoadReviewsAfterQV.bind(this);
  }
  scrollToTop() {
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      500
    );
  }
  goToReviewSection() {
    var headerOffset = 115;
    if (this.props.passedAppFunctions.siteFormat == 'mobile') {
      headerOffset = 0;
    }
    $('html, body').animate(
      {
        scrollTop: $('.review-detail-section').offset().top - headerOffset,
      },
      500
    );
  }
  goToNextPage() {
    this.goToReviewSection();
    this.state.pagingFrom = (this.state.pagingFrom || 0) + 10;
    this.fetchReviews();
  }
  goToPrevPage() {
    this.goToReviewSection();
    this.state.pagingFrom = Math.max(this.state.pagingFrom, 10) - 10;
    this.fetchReviews();
  }
  shouldComponentUpdate(nextProps, nextState) {
    //only update if salePage param changes, productId changes, or reviews get populates, or new data arrives in apiResponse
    if (
      this.state.histogramSizeTrue != nextState.histogramSizeTrue ||
      this.state.histogramSizeSmall != nextState.histogramSizeSmall ||
      this.state.histogramSizeBig != nextState.histogramSizeBig ||
      this.state.liveReviewCount != nextState.liveReviewCount ||
      this.props.contentData.salePage != nextProps.contentData.salePage ||
      this.props.contentData.productId != nextProps.contentData.productId ||
      nextState.apiResponse
    ) {
      return true;
    }
    return false;
  }

  componentDidMount() {
    this.lazyLoadReviews();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.contentData.productId && this.props.contentData.productId != prevProps.contentData.productId) {
      //need to call for new reviews after dumping old
      this.state.liveReviewCount = false;
      this.state.liveReviewStars = false;
      this.state.pagingFrom = false;
      this.state.sortOrder = 'Newest';
      this.lazyLoadReviewsAfterQV();
    }
  }
  updateSortBy(e) {
    // Acceptable fields include LowestRating, HighestRating, MostHelpful, Oldest, Newest.
    var newValue = e.target.value;
    var oldValue = this.state.sortOrder;
    var acceptableFields = ['LowestRating', 'HighestRating', 'Oldest', 'Newest'];
    if (newValue != oldValue && acceptableFields.indexOf(newValue) > -1) {
      this.state.sortOrder = newValue;
      this.state.pagingFrom = false;
      this.fetchReviews();
    }
  }

  lazyLoadReviewsAfterQV() {
    setTimeout(this.fetchReviews(), 1000);
  }

  lazyLoadReviews() {
    if (window.IntersectionObserver) {
      if (pwrReviewsObserver) {
        pwrReviewsObserver.disconnect();
      }
      var reviewSection = document.querySelector('.review-detail-section');
      var pwrReviewsObserver = new IntersectionObserver(
        (entries, pwrReviewsObserver) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.fetchReviews();
              pwrReviewsObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px 200px 0px' }
      );
      pwrReviewsObserver.observe(reviewSection);
    }
  }

  fetchReviews() {
    try {
      if (this.props.contentData.partNumber) {
        var merchantId = this.props.passedAppFunctions.wasParms.powerReviewsMerchantId;
        var locale = 'en_US';
        var pageId = this.props.contentData.partNumber;
        var apiKey = this.props.passedAppFunctions.wasParms.powerReviewsAPIKey;

        // merchantId = '689225';
        // apiKey = 'e17667f7-827b-4880-8fe1-ab55b0a692b9';//testing prod reviews

        var apiUrl = `https://readservices-b2c.powerreviews.com/m/${merchantId}/l/${locale}/product/${pageId}/reviews?apikey=${apiKey}&paging.size=10&sort=${this.state.sortOrder}`;
        if (this.state.pagingFrom) {
          apiUrl += `&paging.from=${this.state.pagingFrom}`;
        }

        var axiosConfig = {
          url: apiUrl,
        };
        axios(axiosConfig).then((ajaxResponse) => {
          var responseData = ajaxResponse.data;
          var apiResponse = responseData.results[0];
          var apiPaging = responseData.paging;
          // console.log(apiResponse, apiPaging);

          if (apiResponse.rollup) {
            var liveReviewCount = apiResponse.rollup.review_count;
            var liveReviewStars = apiResponse.rollup.average_rating;
            var histogramSizeTrue = 0;
            var histogramSizeBig = 0;
            var histogramSizeSmall = 0;
            var properties = apiResponse.rollup.properties;

            for (var iProperty = 0; iProperty < properties?.length; iProperty++) {
              var thisProperty = properties[iProperty];
              if (thisProperty.key == 'size') {
                for (var iValue = 0; iValue < thisProperty.values.length; iValue++) {
                  var thisValueLabel = thisProperty.values[iValue].label;

                  if (thisValueLabel == 'True to size') {
                    histogramSizeTrue = thisProperty.values[iValue].count;
                  }
                  if (thisValueLabel == 'Runs too small') {
                    histogramSizeSmall = thisProperty.values[iValue].count;
                  }
                  if (thisValueLabel == 'Runs too big') {
                    histogramSizeBig = thisProperty.values[iValue].count;
                  }
                }
              }
            }

            this.props.passedFunctions.updateLiveReviewCounts(liveReviewCount, liveReviewStars);
            this.setState({
              apiResponse: apiResponse,
              apiPaging: apiPaging,
              liveReviewCount: liveReviewCount,
              liveReviewStars: liveReviewStars,
              histogramSizeTrue: histogramSizeTrue,
              histogramSizeSmall: histogramSizeSmall,
              histogramSizeBig: histogramSizeBig,
            });
          } else {
            if (apiPaging && (apiPaging.total_results || 0) == 0) {
              this.props.passedFunctions.updateLiveReviewCounts('0', '0');
              this.setState({ liveReviewCount: '0', liveReviewStars: '0' });
            } else {
              this.setState({ apiResponse: apiResponse, apiPaging: apiPaging });
            }
          }
        });
      }
    } catch (e) {
      // console.log(e);
      this.setState({ liveReviewCount: false, liveReviewStars: false });
    }
  }
  generateReviewStars(reviewStars, bigStars) {
    var numOfStars = reviewStars;
    var returnElements = [];
    for (var iStar = 0; iStar <= 4; iStar++) {
      if (Math.floor(numOfStars) > iStar) {
        returnElements.push(
          <i key={iStar} className={`icon star-full ${bigStars ? 'star-big' : ''}`}>
            <span className='sr-only'>{`Rated ${numOfStars} out of 5 stars`}</span>
          </i>
        );
      } else if (numOfStars > iStar) {
        returnElements.push(
          <i key={iStar} className={`icon star-half ${bigStars ? 'star-big' : ''}`}>
            <span className='sr-only'>{`Rated ${numOfStars} out of 5 stars`}</span>
          </i>
        );
      } else {
        returnElements.push(
          <i key={iStar} className={`icon star-empty ${bigStars ? 'star-big' : ''}`}>
            <span className='sr-only'>{`Rated ${numOfStars} out of 5 stars`}</span>
          </i>
        );
      }
    }
    return returnElements;
  }
  timeAgoFromTimestamp(timestamp) {
    var daysAgo = Math.max(Math.round((new Date().getTime() - new Date(timestamp).getTime()) / 86400000), 1);
    var unitToShow = 'year';
    var numberToShow = 0;
    if (daysAgo <= 30) {
      unitToShow = 'day';
      numberToShow = daysAgo;
    } else if (daysAgo < 365) {
      unitToShow = 'month';
      numberToShow = Math.round(daysAgo / 30);
    } else {
      numberToShow = Math.round(daysAgo / 365);
    }
    return `${numberToShow} ${unitToShow}${numberToShow > 1 ? 's' : ''} ago`;
  }
  sizeFitFromReview(review) {
    var returnString = '';
    if (review && review.details && review.details.properties && review.details.properties.length > 0) {
      for (var iProperty = 0; iProperty < review.details.properties.length; iProperty++) {
        var thisProperty = review.details.properties[iProperty];
        if (thisProperty.key == 'size') {
          returnString = thisProperty.value[0];
        }
      }
    }
    return returnString;
  }
  render() {
    if (
      this.props.contentData.reviews &&
      this.props.contentData.reviews.reviewURL &&
      this.props.contentData.salePage &&
      this.props.contentData.salePage == 'true'
    )
      this.props.contentData.reviews.reviewURL += '&salePage=true';

    var reviewCount = (this.state.liveReviewCount || this.props.contentData.reviewCount || 0) * 1;
    var reviewStars = (this.state.liveReviewStars || this.props.contentData.reviewStars || 0) * 1;

    var reviewSizeSum =
      +this.state.histogramSizeTrue + +this.state.histogramSizeSmall + +this.state.histogramSizeBig || 0;
    var reveiewSizeTrue = { width: `${(this.state.histogramSizeTrue / reviewSizeSum) * 100 || 0}%` };
    var reviewSizeSmall = { width: `${(this.state.histogramSizeSmall / reviewSizeSum) * 100 || 0}%` };
    var reviewSizeBig = { width: `${(this.state.histogramSizeBig / reviewSizeSum) * 100 || 0}%` };

    var reviewMessage = 0;
    if (reviewStars > 0) {
      reviewMessage = `${reviewStars} `;
    } else {
      reviewMessage = 'No reviews';
    }

    return (
      <>
        <div className='col-sm-12 m-b-30 review-detail-section justify-content-md-center'>
          {this.props.passedFunctions.parentState.reviewCount == undefined && this.props.contentData.reviews && (
            <div className='noReviewsSection row justify-content-center align-items-center align-items-stretch'>
              <h2 className='col-12'>Ratings & Reviews</h2>

              {/* Hide Fit rating on pages that don't have the data. */}
              {this.state.histogramSizeTrue > 0 ||
              this.state.histogramSizeBig > 0 ||
              this.state.histogramSizeSmall > 0 ? (
                <>
                  <div
                    className={`${this.props.passedAppFunctions.siteFormat == 'mobile' ? 'stars col text-right d-flex align-items-center' : 'stars col text-right'}`}
                  >
                    <div className='starsWrapper'>
                      <span>{reviewMessage}</span>
                      <span className='sr-only'>{`Rated ${reviewStars} out of 5 stars`}</span>
                      {this.generateReviewStars(reviewStars, true)}
                    </div>
                  </div>
                  <div className='fitRating col text-left'>
                    <ul>
                      <li>
                        <span className='fitRatingLabel'>Runs too small</span>
                        <div className='fitRating-histogram-bar'>
                          <div className='fitRating-barValue' style={reviewSizeSmall}></div>
                        </div>
                        <span className='fitRatingCount'>{this.state.histogramSizeSmall || 0}</span>
                      </li>
                      <li>
                        <span className='fitRatingLabel'>True to size</span>
                        <div className='fitRating-histogram-bar'>
                          <div className='fitRating-barValue' style={reveiewSizeTrue}></div>
                        </div>
                        <span className='fitRatingCount'>{this.state.histogramSizeTrue || 0}</span>
                      </li>
                      <li>
                        <span className='fitRatingLabel'>Runs too big</span>
                        <div className='fitRating-histogram-bar'>
                          <div className='fitRating-barValue' style={reviewSizeBig}></div>
                        </div>
                        <span className='fitRatingCount'>{this.state.histogramSizeBig || 0}</span>
                      </li>
                    </ul>
                  </div>
                </>
              ) : (
                <div className='stars col border-0'>
                  <div className='starsWrapper'>
                    <span>{reviewMessage}</span>
                    {this.generateReviewStars(reviewStars, true)}
                  </div>
                </div>
              )}
              <div className='col-12'>
                <Link
                  to={(this.props.contentData.reviews.reviewURL += '&pr_headline=Product Review')}
                  className='pr-snippet-write-review-link'
                >
                  Write a Review
                </Link>
              </div>
            </div>
          )}
          <div className='col-sm-12' id='pr-reviewdisplay'>
            {this.state.liveReviewCount && reviewCount > 0 ? (
              <div className='row'>
                <div className='col-sm-8 p-0'>
                  <h3 id='reviewed-by'>
                    Reviewed by {reviewCount} customer{reviewCount > 1 ? 's' : ''}
                  </h3>
                </div>
                <div className='col-sm-4 p-0' id='pr-rd-sort-by'>
                  <label htmlFor='reviewSortBy' className='sr-only'>
                    Sort Reviews By
                  </label>
                  <select className='form-control' onChange={this.updateSortBy} id='reviewSortBy'>
                    <option value='Newest'>Most Recent</option>
                    <option value='LowestRating'>Lowest Rated</option>
                    <option value='HighestRating'>Highest Rated</option>
                    <option value='Oldest'>Oldest</option>
                  </select>
                </div>
                <div className='reviews-section col-sm-12 p-0'>
                  {this.state.apiResponse.reviews.map((thisReview) => {
                    return (
                      <div
                        key={thisReview.review_id}
                        className='col-sm-12 row'
                        role='group'
                        aria-label='product review'
                      >
                        <div className='col-sm-3' id='pr-author-details'>
                          <h4>{thisReview.details.nickname}</h4>
                          <div>{thisReview.details.location}</div>
                          {thisReview.details.disclosure_code == 'sweepstakes' &&
                            thisReview.details.comments.indexOf('#sweepstakes' || '#Sweepstakes') > -1 && (
                              <div>Submitted as part of a sweepstakes entry</div>
                            )}
                        </div>
                        <div className='col-sm-7' id='review-comments'>
                          <div>
                            {this.generateReviewStars(thisReview.metrics.rating)}{' '}
                            <span>{thisReview.details.headline}</span>
                          </div>
                          <p>{thisReview.details.comments}</p>
                        </div>
                        <div className='col-sm-2'>
                          <div id='pr-date'>{this.timeAgoFromTimestamp(thisReview.details.created_date)}</div>
                          {thisReview.details.properties && this.sizeFitFromReview(thisReview) && (
                            <div id='pr-date'>
                              <strong>Fit: </strong>
                              {this.sizeFitFromReview(thisReview)}
                            </div>
                          )}
                          {thisReview.details.source == 'syndicated' && (
                            <div className='syndicated'>
                              <span>SYNDICATED REVIEW</span>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className='col-sm-4 reviews-count'>
                  {reviewCount > 1 &&
                    (this.state.apiResponse.reviews.length === 1
                      ? `Displaying review ${this.state.apiPaging.total_results}`
                      : `Displaying reviews ${(this.state.apiPaging.current_page_number - 1) * 10 + 1}-${Math.min(this.state.apiPaging.current_page_number * 10, this.state.apiPaging.total_results)}`)}{' '}
                </div>
                <div className='col-sm-4 reviews-back-top'>
                  <button className='btn btn-tertiary' aria-label='back to top' onClick={this.goToReviewSection}>
                    back to top
                    <span className='sr-only' aria-label='of ratings and reviews section'>
                      {' '}
                      of ratings and reviews section
                    </span>
                  </button>
                </div>
                <div className='col-sm-4 reviews-pagination'>
                  {this.state.apiPaging.pages_total > 1 && (
                    <>
                      {this.state.apiPaging.current_page_number > 1 && (
                        <button className='btn btn-tertiary' onClick={this.goToPrevPage}>
                          Previous
                        </button>
                      )}
                      {this.state.apiPaging.current_page_number > 1 &&
                        this.state.apiPaging.current_page_number < this.state.apiPaging.pages_total &&
                        ' | '}
                      {this.state.apiPaging.current_page_number < this.state.apiPaging.pages_total && (
                        <button className='btn btn-tertiary' onClick={this.goToNextPage}>
                          Next
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default ProductDetailReviews;
